module.exports = __webpack_public_path__ + "img/dental-office-tour-room2.3959454b.jpeg";